import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <nav className="navigation-header">
      <Link to="/" className="navigation-logo">
        Honey Sofia
      </Link>
      
      {/* Desktop Menu */}
      <ul className="navigation-menu">
        <li>
          <Link to="/" className={`navigation-link ${isActive('/')}`}>
            Home
          </Link>
        </li>
        <li>
          <Link to="/about" className={`navigation-link ${isActive('/about')}`}>
            About
          </Link>
        </li>
        <li>
          <Link to="/experience" className={`navigation-link ${isActive('/experience')}`}>
            Experience
          </Link>
        </li>
        <li>
          <Link to="/bookings" className={`navigation-link ${isActive('/bookings')}`}>
            Bookings
          </Link>
        </li>
        <li>
          <Link to="/tours" className={`navigation-link ${isActive('/tours')}`}>
            Tours
          </Link>
        </li>
        <li>
          <Link to="/gallery" className={`navigation-link ${isActive('/gallery')}`}>
            Gallery
          </Link>
        </li>
        <li>
          <Link to="/dakota-joy" className={`navigation-link ${isActive('/dakota-joy')}`}>
            Honey + Dakota
          </Link>
        </li>
        <li>
          <Link to="/friends" className={`navigation-link ${isActive('/friends')}`}>
            Friends
          </Link>
        </li>
        <li>
          <Link to="/newsletter" className={`navigation-link ${isActive('/newsletter')}`}>
            Newsletter
          </Link>
        </li>
        <li>
          <Link to="/faq" className={`navigation-link ${isActive('/faq')}`}>
            FAQ
          </Link>
        </li>
      </ul>

      {/* Mobile Menu Button */}
      <button
        className="mobile-menu-button"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        aria-label="Toggle menu"
      >
        {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu">
          <Link to="/" className={`mobile-menu-link ${isActive('/')}`} onClick={closeMobileMenu}>
            Home
          </Link>
          <Link to="/about" className={`mobile-menu-link ${isActive('/about')}`} onClick={closeMobileMenu}>
            About
          </Link>
          <Link to="/experience" className={`mobile-menu-link ${isActive('/experience')}`} onClick={closeMobileMenu}>
            Experience
          </Link>
          <Link to="/bookings" className={`mobile-menu-link ${isActive('/bookings')}`} onClick={closeMobileMenu}>
            Bookings
          </Link>
          <Link to="/tours" className={`mobile-menu-link ${isActive('/tours')}`} onClick={closeMobileMenu}>
            Tours
          </Link>
          <Link to="/gallery" className={`mobile-menu-link ${isActive('/gallery')}`} onClick={closeMobileMenu}>
            Gallery
          </Link>
          <Link to="/dakota-joy" className={`mobile-menu-link ${isActive('/dakota-joy')}`} onClick={closeMobileMenu}>
            Honey + Dakota
          </Link>
          <Link to="/friends" className={`mobile-menu-link ${isActive('/friends')}`} onClick={closeMobileMenu}>
            Friends
          </Link>
          <Link to="/newsletter" className={`mobile-menu-link ${isActive('/newsletter')}`} onClick={closeMobileMenu}>
            Newsletter
          </Link>
          <Link to="/faq" className={`mobile-menu-link ${isActive('/faq')}`} onClick={closeMobileMenu}>
            FAQ
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
